import { render, staticRenderFns } from "./CardButtons.vue?vue&type=template&id=5319df9d&"
import script from "./CardButtons.vue?vue&type=script&lang=ts&"
export * from "./CardButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports